export default __webpack_public_path__ + "static/media/bracket-left.1216a4b3.svg";